"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var PriceOrigin_1 = require("./PriceOrigin");
/**
 * The simplest representation of the price with a vat. It was designed to be used by ProductPurchasePrice.
 *
 * @author Jan Prokop
 */


var PriceWithVat =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceWithVat, _DomainObject_1$Domai);

  /**
   * @param value Price value
   * @param vatValue Vat value
   * @param origin Origin of the price - could be average from transactions or from price list.
   */
  function PriceWithVat(value) {
    var _this;

    var vatValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, PriceWithVat);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceWithVat).call(this));
    _this.value = value;
    _this.vatValue = vatValue;
    _this.origin = origin;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to price with vat.
   */


  _createClass(PriceWithVat, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new PriceWithVat(mat.value, mat.vatValue, mat.origin);
    }
  }]);

  return PriceWithVat;
}(DomainObject_1.DomainObject);

exports.PriceWithVat = PriceWithVat;

PriceWithVat.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceWithVat.name);
  return {
    value: builder.bigNum('value'),
    vatValue: builder.opt(builder.bigNum('vatValue')),
    origin: builder.opt(builder.senum('origin', PriceOrigin_1.PriceOrigin, 'seq'))
  };
}();